import React from "react";
import { Card, Grid, Typography } from '@curves/ui-base';

import ReadTextField from "@Local/Components/ReadTextField";
const ReceiverSectionByRead = props => {
	const { receiverName, receiverMobile, receiverAddress, receiverNotes } = props;
	return (
		<Card>
			<Card.CardHeader
				title={
					<Typography variant="body-1" className="font-weight-900">
						收件人資訊
					</Typography>
				}
				className="bg-black"
			/>
			<Card.CardContent className="p-4">
				<Grid spacing={3} container>
					<Grid xs={4} item>
						<ReadTextField label="收件人">{receiverName}</ReadTextField>
					</Grid>
					<Grid xs={4} item>
						<ReadTextField label="收件手機">{receiverMobile}</ReadTextField>
					</Grid>
					<Grid xs={12} item>
						<ReadTextField label="收件地址">{receiverAddress}</ReadTextField>
					</Grid>
					<Grid xs={12} item>
						<ReadTextField label="備註">{receiverNotes}</ReadTextField>
					</Grid>
				</Grid>
			</Card.CardContent>
		</Card>
	);
};
export default ReceiverSectionByRead;
